var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBudgetiForecastingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 99,
    viewBox: "0 0 98 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49.5938,
    r: 49,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.0013,
    cy: 49.5941,
    r: 40.8333,
    fill: "#FD8A4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.8675 44.1104H40.1309C36.7578 44.1104 34.0234 46.8221 34.0234 50.1672C34.0234 53.5123 36.7578 56.2241 40.1309 56.2241H58.8675C62.2406 56.2241 64.9749 53.5123 64.9749 50.1672C64.9749 46.8221 62.2406 44.1104 58.8675 44.1104Z",
    fill: "#03121C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8675 42.9639H40.1309C36.7578 42.9639 34.0234 45.6756 34.0234 49.0207C34.0234 52.3659 36.7578 55.0776 40.1309 55.0776H58.8675C62.2406 55.0776 64.9749 52.3659 64.9749 49.0207C64.9749 45.6756 62.2406 42.9639 58.8675 42.9639Z",
    fill: "#0D5C9C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6691 54.2403C61.5757 54.2403 63.9319 51.9036 63.9319 49.021C63.9319 46.1385 61.5757 43.8018 58.6691 43.8018C55.7625 43.8018 53.4062 46.1385 53.4062 49.021C53.4062 51.9036 55.7625 54.2403 58.6691 54.2403Z",
    fill: "#42A2DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6852 44.6211L56.0508 49.8181H58.6875L57.5829 54.0231L61.86 48.5892H59.2576L59.6852 44.6211Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4458 30.6104H32.6875V32.8326H57.4458V30.6104Z",
    fill: "#42A2DA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1709 30.6104H63.7227V32.8326H71.1709V30.6104Z",
    fill: "#0D5C9C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6864 34.8076H27.832V36.9448H51.6864V34.8076Z",
    fill: "#42A2DA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7037 34.8076H57.4766V36.9448H66.7037V34.8076Z",
    fill: "#42A2DA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.616 38.9697H39.7617V41.1069H63.616V38.9697Z",
    fill: "#0D5C9C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1395 57.9053H34.2852V60.0425H58.1395V57.9053Z",
    fill: "#0D5C9C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7046 57.9053H64.9766V60.0425H68.7046V57.9053Z",
    fill: "#0D5C9C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2111 62.0605H27.832V64.1977H46.2111V62.0605Z",
    fill: "#42A2DA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.294 66.2148H46.2109V68.352H67.294V66.2148Z",
    fill: "#0D5C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetiForecastingIcon);
export default __webpack_public_path__ + "static/media/BudgetiForecastingIcon.2c3a4c4c78100795053e4f4b200f3dd0.svg";
export { ForwardRef as ReactComponent };